
$(document).ready(function() {
    if($('.flw-audio-list').length) {        
        $('.flw-audio-list').each(function(){
		
            var embed = $(this);
            var ID = parseInt(embed.data('id'));
            var type = embed.data('type');
			var players = {};
            
            if ((type == 'a520_audio_series' || type == 'a510_video_series') && ID > 0) {
                var playerID = 'player-' + type + '-' + ID;
                var controlsID = 'controls_' + playerID;
				
                var xmlhttp = new XMLHttpRequest();
				var url = '/json/podcastlistf.json?series=' + ID;
                if (type == 'a510_video_series') {
                    url = '/json/podcastlistvideof.json?series=' + ID;
                }
				
				xmlhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						try {
							embed.replaceWith( '<div id="wrap_' + playerID + '" class="audio-playlist-wrap"><div id="' + playerID + '" class="audio audio-playlist"></div><div id="' + controlsID + '" class="audio-playlist"></div></div>' );
							var data = JSON.parse(this.responseText);
							players[playerID] = flowplayer('#' + playerID , {
								src: {
									type: "flowplayer/playlist", 
									items: data.playlist
								},
								playlist: {
									advance: true,
									controls: '#' + controlsID,
								},
								logo: data.image,
								token: cyclone3.fkey,
								interval: 5,
								audioOnly: true,
								splash: true
							});
							$('#' + playerID).append('<div class="audio-playlist-description"><h4> '+ data.title + '</h4>' + data.summary + '</div>');
							
						} catch(e) {
							// add notification if error
							$('#' + playerID).replaceWith($('<div "' + playerID + '" class="player-error"><p><span>404</span><span>Audio nie je dispozícii</span></p></div>'));
							$('#' + controlsID).remove();							
						}
					}
				};
				xmlhttp.open("GET", url, true);
				xmlhttp.send();
            }
        })        
    }    
});